import Vue from 'vue'

export default {
  setInfrastructureEdit(state, data) {
    state.infrastructureEdit = data
  },
  setInfrastructureMapParams(state, data) {
    state.infrastructureMapParams = data
  },
  updateInfrastructureMapData(state, data) {
    state.infrastructureMapData = Object.assign({}, state.infrastructureMapData, data)
  },
  setInfrastructureMapObject(state, data) {
    state.infrastructureMapObject = data
  },
  setInfrastructureTechnology(state, data) {
    state.infrastructureTechnology = data
  },
  setInfrastructureTechnologies(state, data) {
    state.infrastructureTechnologies = data
  },
  setInfrastructureTechnologyTree(state, data) {
    state.infrastructureTechnologyTree = data
  },
  setInfrastructureTechnologyEdit(state, data) {
    state.infrastructureTechnologyEdit = data
  },
  setInfrastructureTechnologyCreated(state, data) {
    state.infrastructureTechnologyCreated = data
  },
  setInfrastructureTechnologyCurrentParams(state, data) {
    state.infrastructureTechnologyCurrentParams = data
  },
}



// WEBPACK FOOTER //
// ./src/store/infrastructures/mutations.js